import { UIGraphEdge, UIGraphElement, UIGraphNode } from "../../types/graph";

export const getSelectedElementsByType = (
  elements: UIGraphElement["data"][],
): {
  edges: UIGraphEdge["data"][];
  nodes: UIGraphNode["data"][];
} => {
  return {
    edges: elements.filter(
      (element): element is UIGraphEdge["data"] => element.type === "edge",
    ),

    nodes: elements.filter(
      (element): element is UIGraphNode["data"] => element.type === "node",
    ),
  };
};
